var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEveronLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 28,
    viewBox: "0 0 126 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.8672 18.4656C52.4268 21.967 47.5461 22.8424 43.9344 20.4433C40.2901 18.0441 39.3465 13.0838 41.7869 9.45271C44.3574 5.62709 49.2381 4.55722 52.9474 6.98876C54.7696 8.18831 55.9409 10.0363 56.2663 12.1112L43.3487 12.0788C42.6979 12.0788 42.1773 12.5975 42.1773 13.2459C42.1773 13.8943 42.6979 14.4131 43.3487 14.4131H58.8043V14.0564C58.9019 10.4902 57.1774 7.18328 54.1513 5.17321C49.2706 1.93116 43.1209 3.19556 39.8346 8.09105C36.5808 12.9541 37.9148 19.1464 42.9582 22.4858C47.4485 25.4684 53.6633 24.2689 56.8195 19.8273L57.0472 19.5031L55.0624 18.2063L54.8672 18.4656Z",
    fill: "#353C3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3897 14.0935C18.2916 18.3333 14.6921 21.9258 10.3401 21.9258C5.95539 21.9258 2.3887 18.1715 2.3887 13.8023C2.3887 9.17412 5.88995 5.61402 10.3729 5.61402C12.5652 5.61402 14.594 6.52023 16.001 8.04136L5.13734 15.0968C4.58107 15.4529 4.45018 16.1972 4.81012 16.7151C5.17007 17.2653 5.92267 17.3947 6.44622 17.0387L19.4041 8.5592L19.2078 8.23555C17.3099 5.22564 14.005 3.41322 10.3401 3.38086C4.48291 3.41322 0 7.81481 0 13.7052C0 19.5308 4.54835 24.0942 10.6346 24.1266C16.0665 24.1266 20.6148 19.5632 20.7457 14.1259V13.7375H18.357L18.3897 14.0935Z",
    fill: "#353C3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1508 20.8572C28.0163 17.9404 22.7326 3.77781 22.7326 3.77781H20.1719L27.1735 22.5425C27.53 23.3851 28.2107 23.936 29.3128 23.936C30.4474 23.936 31.1281 23.3851 31.4522 22.5425L38.1621 4.65285C38.4862 3.87504 37.9028 3 37.06 3C36.5738 3 36.1199 3.29168 35.9579 3.7454C34.7585 6.727 30.5122 18.3293 29.5397 20.8248C29.4749 21.0517 29.2156 21.0517 29.1508 20.8572Z",
    fill: "#353C3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3586 6.37041V3.57129H61.0938V23.5557H63.3586V13.0427C63.3586 8.55112 66.206 5.78454 68.8268 5.78454H69.7004C70.3151 5.78454 70.8005 5.29633 70.8005 4.67792C70.8005 4.05951 70.3151 3.57129 69.7004 3.57129H68.665C66.4324 3.57129 64.4587 4.84066 63.3586 6.37041Z",
    fill: "#353C3F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.439 13.5632C101.439 19.3971 96.7096 24.1264 90.8757 24.1264C85.0418 24.1264 80.3125 19.3971 80.3125 13.5632C80.3125 7.7293 85.0418 3 90.8757 3C96.7096 3 101.439 7.7293 101.439 13.5632ZM90.8757 20.0185C94.4408 20.0185 97.331 17.1283 97.331 13.5632C97.331 9.99803 94.4408 7.1079 90.8757 7.1079C87.3105 7.1079 84.4204 9.99803 84.4204 13.5632C84.4204 17.1283 87.3105 20.0185 90.8757 20.0185Z",
    fill: "#353C3F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.519 5.55326C117.861 3.87263 115.553 3 112.854 3C110.156 3 107.848 3.87263 106.19 5.55326C104.597 7.16925 103.719 9.46396 103.719 12.0172V23.5554H108.368V12.0172C108.368 9.43164 110.286 7.46013 112.854 7.46013C115.423 7.46013 117.341 9.43164 117.341 12.0172V23.5554H121.99V12.0172C121.99 9.46396 121.112 7.16925 119.519 5.55326Z",
    fill: "#353C3F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_13725_144627)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.3601 3C75.5262 3 70.7969 7.7293 70.7969 13.5632C70.7969 19.3971 75.5262 24.1264 81.3601 24.1264H90.8763H90.8764C96.7103 24.1264 101.44 19.3971 101.44 13.5632C101.44 7.7293 96.7103 3 90.8764 3H90.8763H81.3601ZM90.8763 3C96.7102 3 101.439 7.7293 101.439 13.5632C101.439 19.3971 96.7102 24.1264 90.8763 24.1264C85.0424 24.1264 80.3131 19.3971 80.3131 13.5632C80.3131 7.7293 85.0424 3 90.8763 3Z",
    fill: "#CFD6D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_13725_144627",
    x: 70.7969,
    y: 3,
    width: 30.6406,
    height: 23.1265,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.301146 0 0 0 0 0.400217 0 0 0 0 0.491667 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_13725_144627"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEveronLogoBlack);
export default __webpack_public_path__ + "static/media/everon-logo-black.0bce93edcfe16eea04504cc0398633be.svg";
export { ForwardRef as ReactComponent };